import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchChecklists} from 'sr/utils/api/checklistApi'
export const fetchChecklistData = createAsyncThunk(
  'checklist/fetchChecklistData',
  async (payload: any) => {
    // Single call instead of double-fetch pattern
    const response = await fetchChecklists({...payload, limit: 10000})
    const data: {checklist_name: string; id: string}[] = []
    const idNameMap: {[key: string]: string} = {}
    response.data.forEach((checklist: any) => {
      idNameMap[checklist.id || checklist._id] = checklist.name
      data.push({
        checklist_name: checklist.name,
        id: checklist.id || checklist._id,
      })
    })
    return {
      data,
      idNameMap,
    }
  },
  {
    condition: (_payload, { getState }) => {
      const { checklist } = getState() as { checklist: { status: string } }
      return checklist.status !== 'succeeded' && checklist.status !== 'loading'
    },
  }
)
